<div onclick="window.open('http://cancerexperienceregistry-dev.org/','mywindow');" class="thumb-container" *ngIf="isRegistryAvailable">
  <div class="img-container">
    <img [src]="cancerExperienceImage" class="cancer-exp" alt="">
  </div>
  <div class="thumb-title">
    <p class="nomargin">{{'Cancer Experience' | translate}}</p>
    <p class="nomargin">{{'Registry' | translate}}</p>
  </div>
</div>
